import { SuratPerjanjianKerjaApi } from "api"
import {
  ActionButton,
  Alert,
  ApprovalStatusButton,
  CreateButton,
  CRUDLayout,
  DataStatus,
  FilterButton,
  InputSearch,
  Pagination,
  ReadButton,
  Table,
  TBody,
  Td,
  TdFixed,
  Th,
  THead,
  ThFixed,
  Tr,
  UpdateButton,
} from "components"
import { useEffect, useState } from "react"
import { ButtonGroup } from "react-bootstrap"
import { IoDocumentOutline, IoDocumentTextOutline } from "react-icons/io5"
import { useHistory, useLocation } from "react-router-dom"
import { DateConvert, PageNumber as TableNumber } from "utilities"
import { GuestMiddleware } from "utilities/GuestMiddleware"
import { ModalFilter } from "./Section"

const SPK = ({ setNavbarTitle }) => {
  const history = useHistory()
  const location = useLocation()
  const state = location?.state
  const [isPageLoading, setIsPageLoading] = useState(true)
  const [data, setData] = useState([])
  const [showModalFilter, setShowModalFilter] = useState(false)
  const [dataFilter, setDataFilter] = useState({
    active: state?.dataFilter?.active,
    tgl_spk_mulai: state?.dataFilter?.tgl_spk_mulai,
    tgl_spk_selesai: state?.dataFilter?.tgl_spk_selesai,
    tgl_penawaran_mulai: state?.dataFilter?.tgl_penawaran_mulai,
    tgl_penawaran_selesai: state?.dataFilter?.tgl_penawaran_selesai,
    customer: state?.dataFilter?.customer,
    unit_produksi: state?.dataFilter?.unit_produksi,
    baseline: state?.dataFilter?.baseline,
    status_approval: state?.dataFilter?.status_approval,
  })
  const [paginationConfig, setPaginationConfig] = useState({
    page: "1",
    dataLength: "10",
    totalPage: "1",
    dataCount: "0",
  })
  const [searchConfig, setSearchConfig] = useState({
    status: false,
    key: "",
  })
  const [alertConfig, setAlertConfig] = useState({
    show: false,
    variant: "primary",
    text: "",
  })

  const [searchTime, setSearchTime] = useState(null)

  const getInitialData = () => {
    setIsPageLoading(true)

    SuratPerjanjianKerjaApi.get({
      q: searchConfig.key,
      page: paginationConfig.page,
      per_page: paginationConfig.dataLength,
      tgl_spk_mulai: dataFilter?.tgl_spk_mulai,
      tgl_spk_selesai: dataFilter?.tgl_spk_selesai,
      tgl_penawaran_mulai: dataFilter?.tgl_penawaran_mulai,
      tgl_penawaran_selesai: dataFilter?.tgl_penawaran_selesai,
      customer: dataFilter?.customer,
      unit_produksi: dataFilter?.unit_produksi,
      baseline: dataFilter?.baseline,
      status_approval: dataFilter?.status_approval,
    })
      .then(({ data }) => {
        setData(data.data)
        setPaginationConfig({
          ...paginationConfig,
          dataCount: data.data_count,
          totalPage: data.total_page,
        })
      })
      .catch((err) => {
        setAlertConfig({
          show: true,
          variant: "danger",
          text: "Data gagal dimuat!",
        })
      })
      .finally(() => setIsPageLoading(false))
  }

  const checkAlert = () => {
    const locationState = location.state

    if (locationState) {
      if (locationState.alert) {
        setAlertConfig({
          show: locationState.alert.show,
          text: locationState.alert.text,
          variant: locationState.alert.variant,
        })
      }
    }
  }

  const dismissAlert = () => {
    let state = { ...history.location.state }
    delete state.alert
    history.replace({ ...history.location, state })

    setAlertConfig({
      ...alertConfig,
      show: false,
    })
  }

  const onInputSearch = (text) => {
    const key = text.target.value
    if (searchTime) clearTimeout(searchTime)
    setSearchTime(
      setTimeout(() => {
        setSearchConfig({
          ...searchConfig,
          key: key,
        })
        setPaginationConfig({
          page: "1",
          dataLength: "10",
          totalPage: "1",
          dataCount: "0",
        })
        setAlertConfig({
          show: key ? true : false,
          variant: "primary",
          text: "Hasil dari pencarian: " + key,
        })
      }, 750)
    )
  }

  useEffect(() => {
    setNavbarTitle("Surat Perjanjian Kerja (SPK)")
    getInitialData()
    checkAlert()

    return () => {
      setIsPageLoading(false)
    }
  }, [
    setNavbarTitle,
    searchConfig.key,
    paginationConfig.page,
    paginationConfig.dataLength,
    dataFilter?.active,
    dataFilter?.tgl_spk_mulai,
    dataFilter?.tgl_spk_selesai,
    dataFilter?.tgl_penawaran_mulai,
    dataFilter?.tgl_penawaran_selesair,
    dataFilter?.customer,
    dataFilter?.unit_produksi,
    dataFilter?.baseline,
    dataFilter?.status_approval,
  ])

  const PageContent = () => {
    const checkStatus = (stat) => {
      const data = stat ? stat.toUpperCase() : ""
      const convert = data.substring(0, 3)

      if (convert === "APP")
        return {
          variant: "outline-success",
          label: "APPROVED",
        }
      // return "APPROVED";
      if (convert === "VER")
        return {
          variant: "outline-success",
          label: "VERIFIED",
        }
      // return "VERIFIED";
      if (convert === "REV")
        return {
          variant: "outline-warning",
          label: "REVISI",
        }
      // return "REVISI";
      if (convert === "REJ")
        return {
          variant: "outline-danger",
          label: "REJECT",
        }
      // return "REJECT";

      return {
        variant: "outline-secondary",
        label: "PENDING",
      }
      // return "PENDING";
    }

    const BarangJadiCollapse = ({ data }) => {
      const [isReadMoreClick, setisReadMoreClick] = useState(false)
      return (
        <>
          <ul className="pl-3 mb-1" style={{ fontSize: "12px" }}>
            {data.map((brg, index) => {
              if (isReadMoreClick) {
                return (
                  <li key={index} index={index}>
                    {brg.nama_item}
                  </li>
                )
              } else {
                return (
                  index < 2 && (
                    <li key={index} index={index}>
                      {brg.nama_item}
                    </li>
                  )
                )
              }
            })}
          </ul>
          {data.length > 2 && (
            <div
              className="text-primary"
              style={{ cursor: "pointer", textDecoration: "underline" }}
              onClick={() => setisReadMoreClick((prev) => !prev)}
            >
              {isReadMoreClick ? "Sembunyikan" : "Selengkapnya..."}
            </div>
          )}
        </>
      )
    }

    const DataTable = () => (
      <>
        <span style={{ fontSize: "14px" }}>
          <b>List Data Surat Perjanjian Kerja (SPK)</b>
        </span>
        <Table>
          <THead>
            <Tr>
              <ThFixed>No</ThFixed>
              <ThFixed>Aksi</ThFixed>
              <ThFixed>Informasi SPK</ThFixed>
              <ThFixed>Informasi Penawaran</ThFixed>
              <Th>Customer</Th>
              <Th>Barang Jadi</Th>
              <Th>Unit Produksi</Th>
              <ThFixed>Baseline</ThFixed>
              <Th>Adendum</Th>
              <ThFixed>Status Approval</ThFixed>
            </Tr>
          </THead>
          <TBody>
            {data.map((val, index) => (
              <Tr key={index}>
                <TdFixed textCenter>
                  {TableNumber(
                    paginationConfig.page,
                    paginationConfig.dataLength,
                    index
                  )}
                </TdFixed>
                <TdFixed>
                  <div className="d-flex justify-content-start">
                    <ButtonGroup size="sm">
                      <ReadButton
                        onClick={() =>
                          history.push(`/transaksi/spk/detail/${val.id_spk}`, {
                            dataFilter,
                          })
                        }
                      />
                      {val.status_approval === "REV" && (
                        <UpdateButton
                          onClick={() =>
                            history.push(`/transaksi/spk/ubah/${val.id_spk}`, {
                              dataFilter,
                              action: "baseline",
                            })
                          }
                        />
                      )}
                      {val.status_approval === "APP" && (
                        <GuestMiddleware>
                          <ActionButton
                            size="sm"
                            variant="success"
                            tooltip
                            tooltipText="Baseline"
                            text={<IoDocumentTextOutline />}
                            onClick={() =>
                              history.push(`/transaksi/spk/ubah/${val.id_spk}`, {
                                dataFilter,
                                action: "baseline",
                              })
                            }
                          />
                        </GuestMiddleware>
                      )}
                      {val.status_approval === "APP" && !val.telah_diadendum && (
                        <GuestMiddleware>
                          <ActionButton
                            size="sm"
                            variant="danger"
                            tooltip
                            tooltipText="Adendum"
                            text={<IoDocumentOutline />}
                            onClick={() =>
                              history.push(`/transaksi/spk/adendum/${val.id_spk}`, {
                                dataFilter,
                              })
                            }
                          />
                        </GuestMiddleware>
                      )}
                    </ButtonGroup>
                  </div>
                </TdFixed>
                <TdFixed>
                  <div>{DateConvert(new Date(val.tgl_spk)).custom}</div>
                  <div>{val.no_spk ?? "-"}</div>
                </TdFixed>
                <TdFixed>
                  <div>{DateConvert(new Date(val.tgl_penawaran)).custom}</div>
                  <div>{val.no_penawaran ?? "-"}</div>
                </TdFixed>
                <Td>{val.nama_customer ?? "-"}</Td>
                <Td>
                  {val.barang_jadi && val.barang_jadi?.length > 0 ? (
                    <BarangJadiCollapse data={val.barang_jadi} />
                  ) : (
                    "-"
                  )}
                </Td>
                <Td>{val.nama_unit_produksi ?? "-"}</Td>
                <TdFixed textCenter>{val.baseline}</TdFixed>
                <Td className="text-nowrap" style={{ color: "#99999F" }}>
                  {val.telah_diadendum ? (
                    <>
                      <div>SUDAH ADA ADENDUM</div>
                      <div>{val.no_spk_adendum}</div>
                    </>
                  ) : (
                    "BELUM ADA ADENDUM"
                  )}
                </Td>
                <TdFixed>
                  <ApprovalStatusButton
                    variant={checkStatus(val.status_approval).variant}
                  >
                    {checkStatus(val.status_approval).label}
                  </ApprovalStatusButton>
                </TdFixed>
              </Tr>
            ))}
          </TBody>
        </Table>
      </>
    )

    if (!data || data.length < 1) {
      return <DataStatus text="Tidak ada data" />
    }

    return (
      <>
        <DataTable />
        {!searchConfig.status && (
          <Pagination
            dataLength={paginationConfig.dataLength}
            dataNumber={
              paginationConfig.page * paginationConfig.dataLength -
              paginationConfig.dataLength +
              1
            }
            dataPage={
              paginationConfig.dataCount < paginationConfig.dataLength
                ? paginationConfig.dataCount
                : paginationConfig.page * paginationConfig.dataLength
            }
            dataCount={paginationConfig.dataCount}
            currentPage={paginationConfig.page}
            totalPage={paginationConfig.totalPage}
            onPaginationChange={({ selected }) =>
              setPaginationConfig({
                ...paginationConfig,
                page: selected + 1,
              })
            }
            onDataLengthChange={(e) =>
              setPaginationConfig({
                ...paginationConfig,
                page: 1,
                dataLength: e.target.value,
              })
            }
          />
        )}
      </>
    )
  }

  return (
    <CRUDLayout>
      {/* head section */}
      <CRUDLayout.Head>
        <CRUDLayout.HeadSearchSection>
          <div className="d-flex mb-3">
            <InputSearch onChange={onInputSearch} />
            <FilterButton active={dataFilter.active} onClick={() => setShowModalFilter(true)} />
          </div>
        </CRUDLayout.HeadSearchSection>
        <CRUDLayout.HeadButtonSection>
          <CreateButton
            onClick={() =>
              history.push("/transaksi/spk/list-penawaran", { dataFilter })
            }
          />
        </CRUDLayout.HeadButtonSection>
      </CRUDLayout.Head>

      {/* alert */}
      <Alert
        show={alertConfig.show}
        variant={alertConfig.variant}
        text={alertConfig.text}
        showCloseButton={true}
        onClose={() => dismissAlert()}
      />

      {/* content */}
      {isPageLoading ? (
        <DataStatus loading={true} text="Memuat data . . ." />
      ) : (
        <PageContent />
      )}

      {/* Modal */}
      {showModalFilter && (
        <ModalFilter
          show={showModalFilter}
          setShow={setShowModalFilter}
          data={dataFilter}
          setData={setDataFilter}
        />
      )}
    </CRUDLayout>
  )
}

export default SPK
